import { PageHead } from "@/components/hm/Basics";

export default function Academia() {
  return (
    <div data-testid="academia-page">
      <PageHead eyebrow="Academia" title="El contenido estará disponible pronto." />
    </div>
  );
}
